import { render } from "./RiHelp.vue?vue&type=template&id=0b5f520e"
import script from "./RiHelp.vue?vue&type=script&lang=js"
export * from "./RiHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiHelp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b5f520e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b5f520e', __exports__)) {
    api.reload('0b5f520e', __exports__)
  }
  
  module.hot.accept("./RiHelp.vue?vue&type=template&id=0b5f520e", () => {
    api.rerender('0b5f520e', render)
  })

}


export default __exports__